export default __webpack_public_path__ + "static/og-image-17a128ad929c938ff99ce39e7d8d92bf.png";